import type { AutoGenReview, AutoGenReviewRequest } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { AUTO_GEN_REVIEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateAutoGenReviews(dispensaryId: string) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();
  const queryClient = useQueryClient();
  const { mutateAsync: updateAutoGenReviews, isPending: isLoadingPatchAutoGenReviews } = useMutation({
    mutationKey: [AUTO_GEN_REVIEWS_KEY],
    mutationFn: (reviewsToUpsert: (AutoGenReview | AutoGenReviewRequest)[]) =>
      banksApi.updateAutoGenReviews(userBankId, dispensaryId, reviewsToUpsert),
    onSuccess: (data) => {
      queryClient.setQueryData([AUTO_GEN_REVIEWS_KEY, userBankId, dispensaryId], data);
    },
    // No success toast — the Internal tab's unified Save already shows one.
    meta: {
      snackbarErrorMessage: 'There was an issue saving Automated Monitoring Reviews'
    }
  });
  return { updateAutoGenReviews, isLoadingPatchAutoGenReviews };
}
